import { render, staticRenderFns } from "./MVMCase.vue?vue&type=template&id=51ef41a9&"
import script from "./MVMCase.vue?vue&type=script&lang=js&"
export * from "./MVMCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports